import { useEffect, useState } from "react";
import { CalendarDays, MapPin, Phone } from "lucide-react";
import { api } from "@/lib/api";
import { Card, PortalPage, Spinner } from "@/components/PortalPage";
import { fmtTime, parseLocal, ymd } from "@/pages/billing/Schedule";

export default function MySchedule() {
  const [d, setD] = useState(null);
  useEffect(() => { api("/billing/my-schedule").then(setD).catch(() => setD({ enabled: false, jobs: [] })); }, []);
  if (!d) return <Spinner />;
  const groups = {};
  d.jobs.forEach((j) => {
    const end = (j.end_at || j.start_at).slice(0, 10);
    for (let day = parseLocal(`${j.start_at.slice(0, 10)}T00:00`), n = 0; ymd(day) <= end && n < 60; day.setDate(day.getDate() + 1), n += 1) {
      (groups[ymd(day)] = groups[ymd(day)] || []).push(j);
    }
  });
  const ends = (j) => (j.end_at && j.end_at.slice(0, 10) !== j.start_at.slice(0, 10) ? ` – ${parseLocal(j.end_at).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" })}, ${fmtTime(j.end_at)}` : j.end_at ? ` – ${fmtTime(j.end_at)}` : "");
  return (
    <PortalPage eyebrow="SCHEDULE" title="My Schedule" width="max-w-3xl" testId="my-schedule">
      {!d.enabled || !d.jobs.length ? <Card><p className="py-6 text-center text-sm text-[#888]" data-testid="my-schedule-empty">No upcoming jobs assigned to you yet.</p></Card> : Object.entries(groups).map(([day, list]) => (
        <Card key={day} className="space-y-3" data-testid={`my-day-${day}`}>
          <p className="flex items-center gap-2 text-xs font-bold tracking-[2px] text-[var(--accent)]"><CalendarDays size={14} />{parseLocal(`${day}T00:00`).toLocaleDateString([], { weekday: "long", month: "long", day: "numeric" }).toUpperCase()}</p>
          {list.map((j) => (
            <div key={j.id} className="space-y-1 border-t border-[#262626] pt-3 text-sm" data-testid={`my-job-${j.id}-${day}`}>
              <p className="font-extrabold">{parseLocal(j.start_at).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" })}, {fmtTime(j.start_at)}{ends(j)} · {j.customer_name}</p>
              <p className="text-[#ccc]">#{j.number} {j.title}</p>
              {j.address && <a className="flex items-center gap-1.5 text-xs text-[#39A0FF]" href={`https://maps.google.com/?q=${encodeURIComponent(j.address)}`} target="_blank" rel="noreferrer" data-testid={`my-job-map-${j.id}`}><MapPin size={12} />{j.address}</a>}
              {j.phone && <a className="flex items-center gap-1.5 text-xs text-[#39A0FF]" href={`tel:${j.phone}`} data-testid={`my-job-phone-${j.id}`}><Phone size={12} />{j.phone}</a>}
              {j.crew?.length > 1 && <p className="text-xs text-[#888]">Crew: {j.crew.join(", ")}</p>}
              {j.notes && <p className="whitespace-pre-line text-xs text-[#A0A0A0]">{j.notes}</p>}
            </div>
          ))}
        </Card>
      ))}
    </PortalPage>
  );
}
